import Component from "../core/Component"
import ScrollService, { scrollToElement } from "../services/Scroll"

export default class Page extends Component {
    constructor(element, options) {
        super(element, (options = {}))
    }

    prepare() {
        document.body.addEventListener("click", this.handleClick)
        ScrollService.on('scroll', this.handleScroll)
    }

    destroy() {
        ScrollService.off('scroll', this.handleScroll)
    }

    handleScroll = ({ y }) => {
        if (y > 200) {
            document.documentElement.classList.add('is-scrolled')
        } else {
            document.documentElement.classList.remove('is-scrolled')
        }
    }

    handleClick = (event) => {
        if (event.defaultPrevented) {
            return
        }
        let target = null

        target = event.target.closest("[data-trigger-click]")
        if (target) {
            this.processClickTrigger(target)
            return
        }

        target = event.target.closest("a")
        if (target) {
            this.processClickATag(target)
            return
        }
    }

    processClickATag(target) {
        const type = Object.prototype.toString.call(target.href)
        const href = type === "[object SVGAnimatedString]" ? target.href.baseVal : target.href
        if (document.location.href.split("#")[0] !== href.split("#")[0]) {
            return
        }

        const id = target.href.split("#")[1]
        if (!id) {
            return
        }

        const element = document.getElementById(id)
        if (!element) {
            return
        }

        event.preventDefault()

        let offset = target.dataset.offset ? target.dataset.offset : 0
        let mode = target.dataset.mode ? target.dataset.mode : "force-center"

        const modalEl = element.closest('[data-component="Modal"]')
        if (modalEl) {
            const modal = Component.getFromElement(modalEl)
            modal?.open()
        } else {
            const modalEls = document.querySelectorAll('[data-component="Modal"]')
            modalEls.forEach(modalEl => {
                const modal = Component.getFromElement(modalEl)
                modal?.close()
            })
        }

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const toggleBlock = this.getToggleBlockComponent(element)
                if (toggleBlock) {
                    const options = JSON.parse(target.dataset.toggleblockOptions || "{}")
                    const action = options.action ?? "open"
                    toggleBlock[action](options, {})
                } else {
                    scrollToElement(element, { offset, mode })
                }
            })
        })
    }

    processClickTrigger(target) {
        const id = target.dataset.triggerClick?.replace("#", "")
        if (!id) {
            return
        }

        const link = document.getElementById(id)
        if (!link) {
            return
        }

        link.click()
    }

    getToggleBlockComponent(element) {
        const toggleBlockEl = element.closest('[data-component="ToggleBlock"]')

        if (toggleBlockEl) {
            const toggleBlock = Component.getFromElement(toggleBlockEl)
            return toggleBlock
        }

        return null
    }
}